import React, { useState, useEffect, useRef } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBInput } from 'mdbreact';
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTasks, faTrash, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'

import AgregarImagenes from '../componentes/AgregarImagenes'
import useTraeDatos from '../hooks/useTraeDatos'
import { traeIdNombre } from '../hooks/Funciones'
import { uid } from 'uid'
import { FieldsProductosCombos } from './productos/FieldsProductosCombos';
import { imagenDefault } from '../hooks/imagenDefault';


const SubirProductos = ({ baseUrl, baseURLInventarios, copiaArray, baseUrlCursos, nombreImpuesto, urlCat, urlAtributos, setFuncion, dataFiltrado, setDataFiltrado }) => {

	const [combinacionAtri, setCombinacionAtri] = useState([])
	const [atributoSelect, setAtributoSelect] = useState({ nombre: '', opciones: [], limite: null, multiple: '' })
	const [respuesta, setRespuesta] = useState({})
	const [categorias, setCategorias] = useState([])
	const [atributos, setAtributos] = useState([])
	const [imagenes, setImagenes] = useState([])
	const [cursos, setCursos] = useTraeDatos(baseUrlCursos)
	const [imagenesNuevas, setImagenesNuevas] = useState(false)
	const [borraImagenes, setBorraImagenes] = useState(false)
	const [checkInvent, setCheckInvent] = useState(false)
	const [checkCombos, setCheckCombos] = useState(false)
	const [checkDescuentoCupones, setCheckDescuentoCupones] = useState(false)
	const [productosEnCombo, setProductosEnCombo] = useState([{
		"id": uid(),
		"cantidad": null,
		"producto": null,
		"atributos": null,
		"opciones": null
	}])

	const [cargandoProducto, setCargandoProducto] = useState(false)
	const buttonCargando = useRef()
	const [visualizacionState, setVisualizacionState] = useState([])
	const [alerta, setAlerta] = useState(0)
	const [producto, setProducto] = useState({
		activo: true,
		nombre: '',
		precio: 0,
		rebajado: 0,
		imagen: null,
		imagePrev: null,
		impuesto: nombreImpuesto,
		categorias: ['todo'],
		tipo: '',
		atributos: []
	})


	const subeCategorias = (cate, index) => e => {

		producto.categorias.map((itemm, index) => {
			if (itemm === cate) {

				let newArr = producto.categorias
				let index = newArr.indexOf(cate);
				if (index > -1) { newArr.splice(index, 1); }

				setProducto({ ...producto, categorias: newArr })

			} else {
				setProducto({ ...producto, categorias: [...producto.categorias, cate] })
			}
		})

	}

	const [error, setError] = useState({
		activo: false,
		mensaje: 'Hola'
	})

	//hace la consulta y trae datos y los almacena en data 
	const peticionTraeDatos = async () => {
		try {
			const getCategoria = axios.get(urlCat)
			const getAtributos = axios.get(urlAtributos)

			const respuesta = await Promise.allSettled([getCategoria, getAtributos]);
			const [{ value: categoriasRespuesta }, { value: atributosRespuesta }] = respuesta

			if (categoriasRespuesta && categoriasRespuesta.data) {
				setCategorias(categoriasRespuesta.data)
			}

			if (atributosRespuesta && atributosRespuesta.data) {
				setAtributos(atributosRespuesta.data)
			}

		} catch (error) {
			console.log(error)
		}
	}

	const errores = codigo => {
		switch (codigo) {
			case 'CampoVacio':
				alert('Hay campos vacios')
				//setError({activo: true, mensaje: 'Hay campos vacios'})
				break
			case 'Precio':
				alert('El Campo Precio debe ser diferente al de reabaja')
				//setError({activo: true, mensaje: 'El Campo Precio debe ser diferente al de reabaja'})
				break
			case 'Imagen':
				alert('El archivo pesa más de 2mb o tiene un formato no admitido')
				//setError({activo: true, mensaje: 'El archivo pesa más de 2mb o tiene un formato no admitido'})
				break
			case 'Limpio':
				setError({ activo: false, mensaje: '' })
				break

		}
	}

	const ValidaImagenes = () => {
		let resultado = false
		let formatosPermitidos = ['.png', '.jpeg', '.jpg']

		imagenes.map(item => {
			let formato = item.imagen.type.replace('image/', '.');

			if (formatosPermitidos.includes(formato)) {
				if (item.imagen.size >= 2000000) { resultado = true }
			} else { resultado = true }
		})
		return resultado
	}

	const PreparaImagenes = async () => {
		const fecha = moment(new Date()).format("YYYYMMDD-HHmmss");
		let RutaServ = 'images/'

		let array = []
		const imagenesArray = [...imagenes]
		if (imagenes.length == 0) {
			const imagen = await imagenDefault()
			imagenesArray.push({ imagePrev: URL.createObjectURL(imagen), imagen, nueva: true })
		}

		setImagenes(imagenesArray)
		imagenesArray.map(item => {
			let NombreImagen = item.imagen.name.replace(/[^A-Z0-9]+/ig, "_");
			let formato = item.imagen.type.replace('image/', '.');
			array.push({
				imagen: item.imagen,
				nombre_imagen: RutaServ + fecha + NombreImagen + formato
			})
		})
		return array

	}

	const PreparaImagenesString = async () => {
		const fecha = moment(new Date()).format("YYYYMMDD-HHmmss");
		let RutaServ = 'images/'

		let array = []

		const imagenesArray = [...imagenes]
		if (imagenes.length == 0) {
			const imagen = await imagenDefault()
			imagenesArray.push({ imagePrev: URL.createObjectURL(imagen), imagen, nueva: true })
		}

		imagenesArray.map(item => {
			let NombreImagen = item.imagen.name.replace(/[^A-Z0-9]+/ig, "_");
			let formato = item.imagen.type.replace('image/', '.');
			array.push({
				nombre_imagen: RutaServ + fecha + NombreImagen + formato
			})
		})
		return array
	}


	const peticionPost = async (e) => {
		e.preventDefault()

		setCargandoProducto(true)
		//	buttonCargando.current.disabled = true;
		let { activo, tipo, curso, nombre, precio, rebajado, cargas, impuesto, categorias, descripcion, descuentouser, referencia } = producto


		let ImagenesListas = await PreparaImagenes()
		let ImagenesListasString = await PreparaImagenesString()
		let IdCurso = traeIdNombre(cursos, curso)


		if (nombre !== '' && impuesto !== '' && precio > 0 && tipo !== '' && tipo !== '' && cargas >= 0 && referencia !== '') {
			if (rebajado !== precio) {
				if (!ValidaImagenes()) {
					let f = new FormData()
					f.append('activo', activo.toString())
					f.append('tipo', tipo)
					f.append('id_curso', IdCurso)
					f.append('nombre', nombre)
					f.append('precio', precio)
					f.append('rebajado', rebajado)
					f.append('imagenes', JSON.stringify(ImagenesListasString))
					f.append('impuesto', impuesto)
					f.append('categoria', JSON.stringify(categorias))
					if (checkCombos) {
						f.append('atributos', JSON.stringify(productosEnCombo))
					} else {
						f.append('atributos', JSON.stringify(combinacionAtri))
					}

					f.append('inventario', checkInvent)
					f.append('descripcion', descripcion)
					f.append('carga', cargas === undefined ? -1 : cargas)
					f.append('METHOD', 'POST')
					f.append('descuentouser', descuentouser !== undefined ? descuentouser : 0)

					f.append('combo', checkCombos)
					f.append('alerta', alerta)

					f.append('descuentoCupones', checkDescuentoCupones)
					f.append('referencia', referencia)

					f.append('visualizacion', JSON.stringify(visualizacionState))

					f.append('imagen0', ImagenesListas[0].imagen)
					f.append('imagen0_nombre', ImagenesListas[0].nombre_imagen)

					if (ImagenesListas[1] !== undefined) {
						f.append('imagen1', ImagenesListas[1].imagen)
						f.append('imagen1_nombre', ImagenesListas[1].nombre_imagen)
					}
					if (ImagenesListas[2] !== undefined) {
						f.append('imagen2', ImagenesListas[2].imagen)
						f.append('imagen2_nombre', ImagenesListas[2].nombre_imagen)
					}
					if (ImagenesListas[3] !== undefined) {
						f.append('imagen3', ImagenesListas[3].imagen)
						f.append('imagen3_nombre', ImagenesListas[3].nombre_imagen)
					}

					axios.post(baseUrl, f)
						.then(response => {
							setProducto({
								activo: true,
								id_curso: IdCurso,
								curso: curso,
								nombre: '',
								tipo: '',
								precio: 0,
								rebajado: 0,
								imagen: null,
								imagePrev: null,
								impuesto: '',
								descripcion: '',
								carga: '',
								categorias: ['todo']
							})
							setImagenes([])
							setCombinacionAtri([])

							setAtributoSelect({
								nombre: '',
								opciones: [""],
								limite: null,
								multiple: ''
							})
							console.log('enviado', response.data)
							setDataFiltrado([
								{
									...response.data,
									activo: true,
									categoria_producto: categorias,
									atributos: combinacionAtri,
									imagePrev: ImagenesListasString,
									url_imagen: ImagenesListasString,
									precio_producto: precio,
									precio_rebajado: rebajado,
									nombre_producto: nombre,
									impuesto_producto: impuesto,
									alerta
								}, ...dataFiltrado])
							setFuncion('ver')
							errores('Limpio')
							setCargandoProducto(false)
							//	buttonCargando.current.disabled = false;
						}).catch(error => {
							console.log('muestra erro: ' + error);
							setCargandoProducto(false)
							//	buttonCargando.current.disabled = false;
						})
				} else {
					setCargandoProducto(false)
					errores('Imagen')
					//buttonCargando.current.disabled = false;
				}
			} else {
				errores('Precio')
				setCargandoProducto(false)
				//	buttonCargando.current.disabled = false;
			}
		} else {
			//	buttonCargando.current.disabled = false;
			setCargandoProducto(false)
			errores('CampoVacio')
		}

	}

	const recibeImagen = e => {

		let picture = e.target.files[0]
		setProducto({ ...producto, imagePrev: URL.createObjectURL(picture), imagen: picture })
		console.log('Imagen: ' + picture)
	}

	//Trae todos datos de la api
	useEffect(() => {
		peticionTraeDatos()
	}, [])


	const [activoSel, setActivoSel] = useState(false)

	const subeCombinacion = e => {

		if (atributoSelect.opciones.length > 1) {

			setCombinacionAtri([
				...combinacionAtri,
				atributoSelect
			])

			setAtributoSelect({
				nombre: '',
				opciones: [],
				limite: null,
				multiple: 'unico'
			})
			console.log('subio')

		} else console.log('campos vacios')
	}


	//sube o limina opcion al selecAtributo
	const subeOpcion = (opcion, index, color) => e => {

		console.log('atributoSelect', atributoSelect)

		atributoSelect.opciones.map((itemm) => {
			if (itemm.id === index) {

				let newArr = atributoSelect.opciones.filter(function (el) { return el.id != index; });
				setAtributoSelect({ ...atributoSelect, opciones: newArr })
				console.log('borro')

			} else {
				setAtributoSelect({
					...atributoSelect,
					opciones: [...atributoSelect.opciones, { opcion: opcion, id: index, color: color }]
				})
				console.log('atributo:', [...atributoSelect.opciones, { opcion: opcion, id: index, color: color }])
			}
		})
	}

	const subePrecioAtributo = (index, e) => {
		atributoSelect.opciones.map((itemm, indexx) => {
			if (itemm.id === index) {
				let copia = atributoSelect.opciones
				copia.map(item => {
					if (item.id === index) {
						item.id = item.id
						item.opcion = item.opcion
						item.precio = e.target.value
						item.color = item.color
					}
				})
				setAtributoSelect({
					...atributoSelect, opciones: copia
				})
			}
		})
	}

	const SeleccionaAtributo = nombre => {

		let NuevoArray = []
		atributos.map((item) => {
			if (item.padre === nombre) {
				NuevoArray.push(item.nombre)
			}
		})

		setAtributoSelect({
			...atributoSelect,
			nombre: nombre,
			opciones: [""],
			limite: null,
			multiple: ''
		})
		setActivoSel(false)

	}

	const eliminaCombinacion = index => e => {
		e.preventDefault()
		setCombinacionAtri(combinacionAtri => combinacionAtri.filter((_, cont) => cont !== index));
	}

	const imprimeArray = array => (
		array.map(item => {
			if (item.opcion !== undefined) {
				return (<span>({item.opcion} ${item.precio}) </span>)
			}
		}
		)
	)

	const ActivaInputAtri = (id) => {
		let resultado = false
		atributoSelect.opciones.map(item => {
			if (item.id === id) { resultado = true }
		})
		return resultado
	}

	const cambiarCheckboxVisualizacion = (event) => {
		const target = event.target;
		const name = target.name;

		if (visualizacionState.includes(name)) {
			const filtrarArray = visualizacionState.filter(function (e) { return e !== name })
			setVisualizacionState(filtrarArray)
		} else {
			setVisualizacionState([...visualizacionState, name])
		}
	}

	const handleCambiarProductosCombos = (nombre, dato, i) => {
		let productos = [...productosEnCombo];
		productos[i] = { ...productos[i], [nombre]: dato };
		setProductosEnCombo(productos)
	}

	const handleCrearProductosCombos = () => {
		setProductosEnCombo([...productosEnCombo, {
			"id": uid(),
			"cantidad": null,
			"producto": null,
			"atributos": null,
			"opciones": null
		}])
	}

	const handleOnEliminarProductosCombos = i => {
		const newArray = productosEnCombo.filter((person) => person.id !== i);
		setProductosEnCombo(newArray);
	}

	return (
		<div>

			<MDBContainer>
				<form onSubmit={peticionPost} >
					<MDBRow>
						<MDBCol>
							<hr />
							{error.activo ?
								<span className="error"> Error: {error.mensaje}</span> : null
							}

							<div className='custom-control custom-switch '>
								<input type='checkbox' name="activo" className='custom-control-input form-control-lg mb-4' id='customSwitches'
									checked={producto.activo}
									onChange={e => setProducto({ ...producto, activo: !producto.activo })}
									readOnly
								/>
								<label className='custom-control-label' htmlFor='customSwitches'>Activar/Desactivar</label>
							</div>

							<div className="row">
								<div className="col-md-9">
									<MDBInput label="Nombre Producto" outline
										value={producto.nombre}
										onChange={e => setProducto({ ...producto, nombre: e.target.value })}
									/>

									<div className="row">
										<div className="col-md-4">
											<label>Tipo Producto</label>
											<select className="browser-default custom-select"
												value={producto.tipo}
												onChange={e => setProducto({ ...producto, tipo: e.target.value })}>
												<option value="">Tipo de Producto</option>
												<option value="Curso">Curso</option>
												<option value="Producto">Producto</option>
											</select>
										</div>
										{producto.tipo === 'Curso' ?
											<div className="col-md-4">
												<label>Selecciona Curso</label>
												<select className="browser-default custom-select"
													value={producto.curso}
													onChange={e => setProducto({ ...producto, curso: e.target.value })}>
													<option>Selecciona Curso</option>
													{cursos.map(item => {
														return (
															<option key={item.id} value={item.nombre}>{item.nombre}</option>
														)
													})}
												</select>
											</div>
											: null}
										<div className="col-md-4">
											<label>Referencia</label>
											<div className="md-form md-outline m-0">
												<input
													type='text'
													required
													placeholder='Referencia'
													className="form-control"
													value={producto.referencia}
													onChange={e => setProducto({ ...producto, referencia: e.target.value })}
												/>
											</div>
										</div>
										<div className="col-md-4">
											<label>Precio Normal</label>
											<div className="md-form md-outline m-0">
												<input
													type='number'
													placeholder='Precio Normal'
													required
													className="form-control"
													value={producto.precio}
													onChange={e => setProducto({ ...producto, precio: e.target.value })}
												/>
											</div>
										</div>
									</div>


									<div className="form-group">
										<label htmlFor="exampleFormControlTextarea1">Descripción:</label>
										<textarea
											value={producto.descripcion}
											onChange={e => setProducto({ ...producto, descripcion: e.target.value })}
											className="form-control" id="exampleFormControlTextarea1" rows="3">

										</textarea>
										<br></br>
										<div>
											<h5>Categorías:</h5>

											{
												categorias.map((item, index) => {

													if (item.nombre !== 'todo') {
														return (
															<div className="custom-control custom-checkbox custom-control-inline" key={index}>
																<input type="checkbox" className="custom-control-input" name={item.id} id={item.nombre}
																	onChange={subeCategorias(item.id, index)} />
																<label className="custom-control-label" htmlFor={item.nombre}>{item.nombre}</label>
															</div>
														)
													}
												})
											}

										</div>

										<div className='mt-2'>
											<h5>Visualización:</h5>

											<div className="custom-control custom-checkbox custom-control-inline">
												<input onChange={cambiarCheckboxVisualizacion} type="checkbox" className="custom-control-input" id="App" name='App' />
												<label className="custom-control-label" htmlFor="App">App</label>
											</div>
											<div className="custom-control custom-checkbox custom-control-inline">
												<input onChange={cambiarCheckboxVisualizacion} type="checkbox" className="custom-control-input" id="Facturación" name='Facturación' />
												<label className="custom-control-label" htmlFor="Facturación">Tienda Física</label>
											</div>
											<div className="custom-control custom-checkbox custom-control-inline">
												<input onChange={cambiarCheckboxVisualizacion} type="checkbox" className="custom-control-input" id="Tienda" name='Tienda' />
												<label className="custom-control-label" htmlFor="Tienda">Página web</label>
											</div>

										</div>

										<div className='mt-2'>
											<h5>Combos:</h5>

											<div className='custom-control custom-switch '>
												<input type='checkbox' name="combos" className='custom-control-input form-control-lg mb-4' id='combos'
													checked={checkCombos}
													onChange={e => { setCheckCombos(!checkCombos); }}
												/>
												<label className='custom-control-label' htmlFor='combos'>Activar Combos</label>
											</div>

										</div>
										{checkCombos ?
											productosEnCombo.map((pro, index) => (
												<FieldsProductosCombos i={index} key={pro.id} value={pro} onChange={handleCambiarProductosCombos} copiaArray={copiaArray} baseURLInventarios={baseURLInventarios} onClick={handleCrearProductosCombos} onRemove={handleOnEliminarProductosCombos} ultimo={productosEnCombo.length - 1 === index} primero={productosEnCombo.length == 1} />
											))
											:
											<div className="row">
												<div className="col-md-12"></div>
												<div className="col-md-12"><hr /></div>
												<div className="col-md-5">
													<h5>Atributos:</h5>

													<select className="browser-default custom-select campos_atributos"
														value={atributoSelect.nombre}
														onChange={e => SeleccionaAtributo(e.target.value)}>
														<option value="">Selecciona Tipo de Atributo</option>
														{
															atributos.map((item, index) => {
																if (item.padre === "")
																	return (
																		<option key={index} value={item.nombre}>{item.nombre}</option>
																	)
															})
														}
													</select>

													<p>Selecciona todas las opciones:</p>
													{
														atributos.map((item, index) => {
															if (item.padre !== "" && atributoSelect.nombre === item.padre)
																return (
																	<div key={index}>
																		<div style={{ display: 'flex' }}>
																			<div className="custom-control custom-checkbox contBoxAtri">
																				<input type="checkbox" className="custom-control-input" id={item.nombre}
																					name={item.nombre}
																					onChange={subeOpcion(item.nombre, index, item.color)} />
																				<label className="custom-control-label" htmlFor={item.nombre}>{item.nombre}</label>
																			</div>
																			<div className='contInputPrecioAtri'>
																				{ActivaInputAtri(index) ?
																					<input onChange={e => subePrecioAtributo(index, e)} className="form-control" type='number' placeholder='precio'></input>
																					: null}
																			</div>

																		</div>
																	</div>

																)
														})
													}


													<div className="text-center mt-4">
														<div className="col text-center">
															<button
																type='button'
																onClick={subeCombinacion}
																className="btn boton_estandar"
															>Crear combinación
															</button>
														</div>
													</div>


												</div>
												<div className="col-md-7">
													<h5>Combinaciones:</h5>

													{
														combinacionAtri.map((item, index) => {
															return (

																<div className="combinacion" key={index}>

																	<div className="row">
																		<div className="col-md-9">
																			<h6>{item.nombre}</h6>
																			<p><span>{imprimeArray(item.opciones)}</span></p>
																			<p>{item.limite !== null ? <b>Limite: </b> : null}
																				{item.limite !== null ? item.limite : null}
																			</p>

																		</div>
																		<div className="col-md-3">
																			<div className="col text-center">
																				<button
																					onClick={eliminaCombinacion(index)}
																					className="btn boton_estandar_blanco"
																				><FontAwesomeIcon icon={faTrashAlt} size="lg" />
																				</button>
																			</div>
																		</div>
																	</div>


																</div>
															)
														})
													}

												</div>
												<hr />


											</div>

										}
										<div className='custom-control custom-switch '>
											<input type='checkbox' name="activo" className='custom-control-input form-control-lg mb-4' id='invent'
												checked={checkInvent}
												onChange={e => { setCheckInvent(!checkInvent); }}
											/>
											<label className='custom-control-label' htmlFor='invent'>Activar Inventario</label>
										</div>

										<div className='custom-control custom-switch '>
											<input type='checkbox' name="activo" className='custom-control-input form-control-lg mb-4' id='descuento'
												checked={checkDescuentoCupones}
												onChange={e => { setCheckDescuentoCupones(!checkDescuentoCupones); }}
											/>
											<label className='custom-control-label' htmlFor='descuento'>Descuento por cupones</label>
										</div>

										{checkInvent && (<div className="row mt-3">
											<div className="col-md-4"><h5>Alertas:</h5> <p className="estados Rojo">Por agotarse</p></div>
											<div className="col-md-8">

												<MDBInput label="Minimo Stock " outline
													value={alerta}
													onChange={e => setAlerta(e.target.value)} />
											</div>
										</div>)}

										<br />
									</div>


								</div>

								{/* COLUMNA DERECHA ------------------------------*/}
								<div className="col-md-3">

									<div className="form-group">
										<AgregarImagenes
											imagenes={imagenes}
											setImagenes={setImagenes}
											setImagenesNuevas={setImagenesNuevas}
											setBorraImagenes={setBorraImagenes}
										/>
									</div>

									<hr></hr>

									<h5>Gestión de Envios:</h5>
									<p style={{ fontSize: 13 }}>Las cargas se asignan según el tamaño o ucupación que tiene dicho producto para ser enviado, puedes usar decimales.</p>
									<MDBInput label="Cargas" outline
										type='number'
										value={producto.cargas}
										onChange={e => setProducto({ ...producto, cargas: e.target.value })}
									/>
									<MDBInput label="% Descuento para Usuario" outline
										type='number'
										value={producto.descuentouser}
										onChange={e => setProducto({ ...producto, descuentouser: e.target.value })}
									/>
								</div>

							</div>


							<div><hr /></div>

							<div className="text-center mt-4">
								<div className="col text-center">
									<button
										ref={buttonCargando}
										type='submit'
										disabled={cargandoProducto}
										className="btn boton_estandar"
									> {cargandoProducto && (<div className="spinner-border spinner-border-sm mr-2" role="status">
										<span className="sr-only">Loading...</span>
									</div>)}Subir Producto
									</button>
								</div>
							</div>
						</MDBCol>
					</MDBRow>
				</form>
			</MDBContainer>
		</div>
	)
}



export default SubirProductos